// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "summary[data-v-5dd630e5]{list-style:none}summary[data-v-5dd630e5]::-webkit-details-marker{display:none}summary span[data-v-5dd630e5]{transition:background-color .3s ease}summary span[data-v-5dd630e5]:after{content:\"+\";margin-top:-4px}details[open]>summary span[data-v-5dd630e5]:after{content:\"-\";margin-top:-1px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
